import { useEffect } from 'react';

import { useGlobalState } from '../../../global_state/src';

const useSetGlobalSearchPlaceholder = (placeholder: string) => {
    const [, setSearchPlaceholder] = useGlobalState('searchPlaceholder');

    useEffect(() => {
        setSearchPlaceholder(placeholder);
    }, [placeholder, setSearchPlaceholder]);
};

export { useSetGlobalSearchPlaceholder };
